import {CitySlug} from "../../../../../config/cities";
import {useAppSelector} from "../../../../../utils/hooks/store_hooks";
import {selectChartsSelectedRegion} from "../../../components/map/redux/map_city_poc_slice";

/** Selected charts region city, falling back to Warsaw when nothing is picked yet. */
export const useEffectiveCitySlug = (): CitySlug => {
    const chartsSelectedRegion = useAppSelector(selectChartsSelectedRegion);

    return chartsSelectedRegion?.citySlug ?? CitySlug.WARSZAWA;
};
